import React, { useEffect } from 'react';
import { CoreAPI, useIdentity } from '../../core';

export const DragAndDropLayer: React.FC<{
    children: React.ReactNode;
    style?: React.CSSProperties;
}> = React.memo(({ children, style }) => {
    const identity = useIdentity();
    const onDropHandle = (e: React.DragEvent<HTMLDivElement>) => {
        CoreAPI(identity).events.emitDropLayer(e);
    };
    const onDragOverHandle = (e: React.DragEvent<HTMLDivElement>) => {
        // TODO 先隐藏这个事件 是用来直接放入到有mask得img图层里面的
        CoreAPI(identity).events.emitDragOverLayer(e);
    };
    const onDragLeaveHandle = (e: React.DragEvent<HTMLDivElement>) => {
        CoreAPI(identity).events.emitDragLeaveLayer(e);
    };

    useEffect(() => {
        const image = new Image();
        image.style.width = '1px';
        image.style.height = '1px';
        image.style.visibility = 'hidden';
        document.body.appendChild(image);
        let defaultWidth = 0;
        let defaultHeight = 0;
        // 偏移修正
        let offsetX = 0;
        let offsetY = 0;
        // 放大起点位置
        let startOffsetX = 0;
        // 放大终点位置
        let endOffsetX = 0;

        const asideRect = document.querySelector('.p-editor__aside')?.getBoundingClientRect();
        if (asideRect) {
            endOffsetX = asideRect.right;
        }

        document.addEventListener(
            'dragstart',
            function (event) {
                const ghost = document.getElementById('mt-drag-ghost');
                if (ghost) {
                    const rect = ghost.getBoundingClientRect();
                    offsetX = event.clientX - rect.left;
                    offsetY = event.clientY - rect.top;
                    defaultWidth = rect.width;
                    defaultHeight = rect.height;
                    // startOffsetX = rect.left + rect.width / 2; // 起点为中心点
                    startOffsetX = event.clientX; // 起点为鼠标位置

                    if (event.dataTransfer) {
                        // 隐藏默认拖拽图像
                        event.dataTransfer.setDragImage(image, 0, 0);
                        event.dataTransfer.effectAllowed = 'move';
                    }
                }
            },
            true,
        );

        document.addEventListener('dragover', function (event) {
            event.preventDefault();
            const ghost = document.getElementById('mt-drag-ghost');
            if (ghost) {
                const maxWidth = +(ghost.dataset.maxWidth ?? '');
                const maxHeight = +(ghost.dataset.maxHeight ?? '');

                if (event.clientX <= startOffsetX) {
                    // 往左拖动
                    ghost.style.left = event.clientX - offsetX + 'px';
                    ghost.style.top = event.clientY - offsetY + 'px';
                } else if (event.clientX >= endOffsetX) {
                    // 往右拖动超过临界值
                    const rate = maxWidth / defaultWidth;
                    ghost.style.width = maxWidth + 'px';
                    ghost.style.height = maxHeight + 'px';
                    ghost.style.left = event.clientX - (defaultWidth / 2) * rate + 'px';
                    ghost.style.top = event.clientY - (defaultHeight / 2) * rate + 'px';
                } else {
                    // 往右拖动接近临界值
                    const slope = (maxWidth - defaultWidth) / (endOffsetX - startOffsetX);
                    const width = defaultWidth + (event.clientX - startOffsetX) * slope;
                    const rate = width / defaultWidth;
                    const height = (defaultHeight / defaultWidth) * width;
                    ghost.style.width = width + 'px';
                    ghost.style.height = height + 'px';
                    // 拖拽点移动到中心点
                    const slopeToCenterX = (defaultWidth / 2 - offsetX) / (maxWidth - defaultWidth);
                    const slopeToCenterY = (defaultHeight / 2 - offsetY) / (maxHeight - defaultHeight);
                    const x = (width - defaultWidth) * slopeToCenterX + offsetX;
                    const y = (height - defaultHeight) * slopeToCenterY + offsetY;
                    ghost.style.left = event.clientX - x * rate + 'px';
                    ghost.style.top = event.clientY - y * rate + 'px';
                }
            }
        });

        document.addEventListener('dragend', function () {
            const ghost = document.getElementById('mt-drag-ghost');
            if (ghost) {
                ghost.remove();
                offsetX = 0;
                offsetY = 0;
            }
        });

        return () => {
            image.remove();
        };
    }, []);

    return (
        <div
            className="l-drag-drop"
            onDrop={onDropHandle}
            // onDragOver={onDragOverHandle}
            // onDragEnter={onDragOverHandle}
            onDragLeave={onDragLeaveHandle}
            data-move-make-up="true"
            style={{
                width: '100%',
                height: '100%',
                pointerEvents: 'auto',
                ...style,
            }}
        >
            {children}
        </div>
    );
});
